<template>
  <div class="w-100 overflow-y-auto">
    <div class="container">
      <h2 class="text-center mb-4">
        {{ $t("novaAssinatura") }}
      </h2>
      <AssinaturaForm class="mb-4" media="" :video="false" :active="true" @salvar-assinatura="onSave" />
    </div>
  </div>
</template>
<script>
import AssinaturaForm from './components/AssinaturaForm';
import { addAssinatura } from './assinaturasService';
import { useToast } from 'vue-toastification';

export default {
  components: { AssinaturaForm },
  methods: {
    async onSave(assinatura) {
      try {
        const response = await addAssinatura(assinatura);
        if (response) {
          useToast().success('Assinatura cadastrada com sucesso.');
          this.$router.push('/admin/assinaturas');
        } else {
          useToast().error(response);
        }
      } catch (error) {
        useToast().error('Erro de conexão');
      }
    },
  },
};
</script>
